/**
 * Hook to fetch conversation history (chat sessions) from the API.
 */

import { useState, useCallback, useEffect } from 'react';
import { fetchChatSessions, type ChatSessionApiResponse } from '../services/chatHistoryService';

export function useConversationHistory() {
    const [details, setDetails] = useState<ChatSessionApiResponse[] | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchDetails = useCallback(async () => {
        setLoading(true);
        try {
            const data = await fetchChatSessions();
            const normalized = Array.isArray(data) ? data : [];
            setDetails(normalized);
            setError(null);
        } catch (err) {
            console.error('[useConversationHistory] fetch error:', err);
            setError(err as Error);
            setDetails(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    return { details, loading, error, refetch: fetchDetails };
}
